import {useEffect,useState } from 'react'
import { getHistorical , getHistoricalglobal} from "../requests/request"
import { useAppSelector  } from "../../../../../../redux/hooks"
import { useAuth } from '../../../../auth'

type Historical = {
  mes: string,
        "DTR-VPN": number,
        "DTR-CPR": number,
        VPN: number,
        CPR: number,
        Total: number,
        currency: string
        status:string
}

export default function GetResumenconsumo(props:any) {

    const [DataHistorical, setDataHistorical]= useState<Historical[]>([])
    const Id = useAppSelector(state => state.SuscriptionSlice.id)
    const tenant= useAppSelector(state =>state.TenantSlice.id)
    const{currentUser}= useAuth()

      
     /* useEffect( () => {
            if(Id !== 0 && tenant===0 ){
              getHistorical(Id).then(response=>{
                setDataHistorical(response.data)
            })
              
            }
            else if(Id !== 0 && tenant!==0 ){
              getHistoricalglobal(Id,tenant).then(response=>{
                setDataHistorical(response.data)
            })
              
            }

       }, [Id ]
       )*/
       useEffect(() => {
        if (Id !== 0 && tenant === 0 && currentUser?.ListPermiso?.includes('Accounts.Billing')) {
          getHistorical(Id).then(response => {
            const responseData = response.data;
      
            // Verificar si la respuesta es un array y si tiene al menos un elemento
            if (Array.isArray(responseData) && responseData.length > 0) {
              // Si es un array y tiene al menos un elemento, actualiza el estado normalmente
              setDataHistorical(responseData);
            } else {
              // Manejar el caso de "no data" de manera específica
              // Puedes mostrar un mensaje, registrar información, etc.
              console.log("No hay datos disponibles");
            }
          });
        } else if (Id !== 0 && tenant !== 0 && currentUser?.ListPermiso?.includes('Accounts.Billing')) {
          getHistoricalglobal(Id, tenant).then(response => {
            const responseData = response.data;
      
            // Verificar si la respuesta es un array y si tiene al menos un elemento
            if (Array.isArray(responseData) && responseData.length > 0) {
              // Si es un array y tiene al menos un elemento, actualiza el estado normalmente
              setDataHistorical(responseData);
            } else {
              // Manejar el caso de "no data" de manera específica
              // Puedes mostrar un mensaje, registrar información, etc.
              console.log("No hay datos disponibles");
            }
          });
        }
      }, [Id]);
         
       
  
    if(DataHistorical[0]?.Total !== 0 && DataHistorical.length !== 0 && DataHistorical[0].status!=='no data' ){
      return(
        <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
                <div className="card-header bg-marino  flex-center">
                    <h4 className="f-titulo-cards fs-p f-titulo text-w ">SUMMARY OF THE MONTH'S EXCESS CONSUMPTION</h4>
                </div>
                <div className="card-body  ">
                <table className="table table-row-dashed table-row-gray-300 gy-2">
                  <thead className='flex-center'>
                      <tr className="fw-bolder fs-6 text-gray-800 ">
                          <th >Excess Consumption DTR-VPN (GB)</th>
                          <th >Excess Consumption DTR-VPN ({DataHistorical[0]?.currency})</th>
                          <th >Excess Consumption DTR-CPR (GB)</th>
                          <th >Excess Consumption DTR-CPR ({DataHistorical[0]?.currency})</th>
                          <th >Total Excess Consumption ({DataHistorical[0]?.currency})</th>
                      </tr>
                  </thead>
                  <tbody className='flex-center'>
                      {DataHistorical?.map((d:any,i)=>(
                        
                        <tr key={i}>
                            <td>{d['DTR-VPN']} GB</td>
                            <td>$ {d.VPN}</td>
                            <td>{d['DTR-CPR']} GB</td>
                            <td>$ {d.CPR}</td>
                            <td>$ {d.Total}</td>
                        </tr>
                      ))}
                  </tbody>
                  {/*<tfoot>
                    <tr>
                      <td colSpan={2}>C = Consumo</td>
                      <td colSpan={2}>CE = Consumo Excedente</td>
                      <td colSpan={2}>CTE = Consumo Total Excedente</td>
                    </tr>
                  </tfoot> */}
                </table>
            </div>
      </div>
    )
    }else{
      return(
        <div style={{ marginLeft: '15px'}} className="card card-custom flex-column-fluid">
      </div>
    )
    }

 
  
}